import { Button, Modal } from 'react-bootstrap';
import React from 'react';
import CourseService from '../../service/courseService'
import { useParams } from 'react-router-dom';
import useToken from '../../App/useToken';

import './DeleteCourseModal.css'

export default function StudentChangeTermModal({ showDeleteCourseModal, setShowDeleteCourseModal }) {
    const { major_name ,course_name } = useParams();
    const { getToken } = useToken();
    const token = getToken();
  
    const handleClose = () => {
      setShowDeleteCourseModal(false);
    }

    const handleOnDeleteCourse = async e => {
      const courseService = new CourseService();
      const res = await courseService.deleteCourseByName(course_name, token);
      if (res) {
        window.location.pathname = `/majorcourses/${major_name}`;
      }
    }
    return (
      <>
        <Modal
            show={showDeleteCourseModal}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
          >
              <Modal.Header closeButton>
                <Modal.Title>ลบหลักสูตร</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                คุณต้องการลบหลักสูตร(wording for confirm to delete)?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  ปิด
                </Button>
                <Button variant="primary" type='submit' onClick={handleOnDeleteCourse}>บันทึก</Button>
              </Modal.Footer>
        </Modal>
      </>
    );
}